/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useEffect } from 'react'
import { Segment } from 'semantic-ui-react'
import OrderList from '../OrderElement/OrderList'
import humanizeDuration from '../../../helpers/humanizeDuration'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../../NavBar/useBreadcrumb'
import { useCurrentOrders } from './useCurrentOrders'

const isScheduledLater = (o) => {
    if (!o.pickupAt) return false

    const inOneHour = new Date((new Date()).setHours(new Date().getHours() + 1))
    return new Date(o.pickupAt) > inOneHour
}

export const sortByPickupDescThenReceivedDateDesc = (o1, o2) => {
    const now = new Date()

    if (o1.status === 'RECEIVED' && o1.status !== o2.status && !isScheduledLater(o1)) return -1
    if (o2.status === 'RECEIVED' && o1.status !== o2.status && !isScheduledLater(o2)) return 1


    const compare1 = o1.pickupAt || o1.receivedAt
    const compare2 = o2.pickupAt || o2.receivedAt

    if (compare1 < now && compare2 > now) return 1
    if (compare1 > now && compare2 < now) return -1

    return (new Date(compare1)).getTime() - (new Date(compare2).getTime())
}

const OrdersCurrent = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const {orders, refetchCurrentOrders} = useCurrentOrders()
    const unScheduledOrders = (orders || [])
      .filter(order => !order.isScheduledForLater)
      .sort(sortByPickupDescThenReceivedDateDesc)

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.orders'),
            link: false,
        }])
    }, [])

    useEffect(() => {
        if (window.Android && window.Android.stopNotifications) {
            window.Android.stopNotifications()
        }
    }, [])

    useEffect(() => {
        const handler = () => {
            refetchCurrentOrders()
        }
        window.addEventListener('AndroidResume', handler, false)

        return () => {
            window.removeEventListener('AndroidResume', handler)
        }
    }, [refetchCurrentOrders])

    return (
      <Segment
        loading={!orders}
        css={css`
          &.ui.segment {
              margin-top: 0;
          }
      `}>
          <OrderList
            seeText={t('order.notification.handle')}
            emptyText={t('order.all_handled')}
            loading={!unScheduledOrders}
            orders={unScheduledOrders}
            displayDelivery
            getStatusText={(o) => t('order.received_at', {
                dt: `${humanizeDuration(new Date(), o.receivedAt, {
                    round: true,
                    units: ['d', 'h', 'm', 's'],
                })}`,
            })}
          />
      </Segment>
    )
}

export default OrdersCurrent
